import { Component, inject, input } from '@angular/core'
import { toObservable, toSignal } from '@angular/core/rxjs-interop'
import { MatIcon } from '@angular/material/icon'
import { combineLatest, switchMap } from 'rxjs'
import { FilterService } from 'src/app/shared/services/filter/filter.service'

@Component({
  imports: [MatIcon],
  selector: '[app-table-header-filter-button]',
  styles: `
      mat-icon {
        outline: none;
      } 
      :host {
        position: relative;
        width: 1.5rem;
        height: 1.5rem;
        background: none;
        border: none;
      }

      .filter-indicator {
        position: absolute;
        bottom: -0.25rem;
        left: 0.85rem;
        font-size: 0.75rem;
        line-height: 1rem;
        min-width: 1rem;
        padding: 0 0.25rem;
        border-radius: 0.5rem;
        background-color: var(--active-blue);
        color: white;
        z-index: 0;
      }
    `,
  template: `
        <mat-icon svgIcon="filter" />
        @if(filterCount()) {
            <span class="filter-indicator">
                @if(filterCount() > 1) { {{ filterCount() }} } 
                @else { &nbsp; }
            </span>
        }
      `,
})
export class TableHeaderFilterButtonComponent {
  filterService = inject(FilterService)

  public fields = input.required<string[]>()
  public filterGroup = input.required<string>()


  protected filterCount = toSignal(
    combineLatest([
      toObservable(this.filterGroup),
      toObservable(this.fields),
    ]).pipe(
      switchMap(([filterGroup, fields]) => this.filterService.asCount(filterGroup, fields)),
    ),
    { initialValue: 0 },
  )
}